import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import classNames from "classnames";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import LoadingMutation from "../Loading/LoadingMutation";

// HOOKS
import useBroadCast from "../../hooks/useBroadCast";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function BroadCastMain() {
  const router = useHistory();
  const params = useParams();

  const { datas, loading, error, getData } = useBroadCast({
    type: params.type,
  });

  const default_form = {
    title: "",
    description: "",
  };
  const [form, setForm] = useState(default_form);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingMutation, setLoadingMutation] = useState(false);
  const [mutationActive, setMutationActive] = useState(null);

  if (loading) {
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  }

  const onCreateBroadCast = async () => {
    if (form.description.length < 4) {
      alert("ข้อความสั้นเกินไปกรุณากรอกเพิ่มเติม");
      return;
    }
    try {
      setLoadingCreate(true);
      const convertType = params.type === "normal" ? "N" : "D";
      await API.post("MoneyHubAdmin", "/broadcast", {
        body: {
          title: form.title,
          description: form.description,
          type: convertType,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setLoadingCreate(false);
      toast.success("สร้าง broadcast สำเร็จ !");
      setForm(default_form);
      await getData();
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const onDeleteBroadCast = (data) => async (e) => {
    e.stopPropagation();
    try {
      setMutationActive(data._id);
      setLoadingMutation(true);
      await API.del("MoneyHubAdmin", `/broadcast/${data._id}`, {
        body: {
          title: form.title,
          description: form.description,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setLoadingMutation(false);
      await getData();
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const onClickRoute = (data) => {
    const { _id } = data;
    router.push(`/broadCast/info/${_id}?type=${params.type}`);
  };

  const onField = async (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const notify = () => toast("ข้อมูลของคุณพร้อมแล้ว!");

  return (
    <ContainerContent>
      <div className="grid grid-cols-3 mx-4  items-center ">
        {datas?.length > 0 &&
          datas.map((data) => {
            return (
              <div
                className="p-4 cursor-pointer"
                onClick={() => onClickRoute(data)}
              >
                <div className="max-w-sm bg-white border h-full border-gray-100 rounded overflow-hidden shadow-lg flex items-start justify-between">
                  <div className="px-6 py-4 w-full h-96">
                    <div className="text-xl   mb-2 h-8">{data.title}</div>
                    <p className="text-gray-700 text-base">
                      {data.description}
                    </p>
                  </div>
                  <div className="px-4 pt-4 pb-2">
                    {loadingMutation && mutationActive === data._id ? (
                      <React.Fragment>
                        <button
                          disabled
                          // className=" duration-300 bg-transparent cursor-pointer bg-gray-300  text-white font-semibold py-2 px-4 border hover:border-transparent rounded"
                        >
                          <div onClick={notify}>
                            <LoadingMutation />
                          </div>
                          <ToastContainer
                            position="bottom-center"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                          />
                        </button>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <button onClick={onDeleteBroadCast(data)}>
                          <svg
                            className="w-6 h-6 hover:text-red-300 duration-300"
                            fill="#ef4444"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        <div className=" mx-4 ">
          <div className="max-w-sm w-auto h-96 border border-gray-100 rounded overflow-hidden shadow-lg  ">
            <div className="px-6 py-4">
              <div className="font-bold text-base mb-2">
                <label>หัวข้อ</label>
                <input
                  className="block border border-grey-light w-full p-2 rounded"
                  type="text"
                  placeholder="วงเงินเพิ่ม"
                  name="title"
                  onChange={onField}
                  value={form.title}
                />
              </div>
              <div className="text-gray-700 text-base">
                <label>เนื้อหา</label>
                <textarea
                  rows="4"
                  className="block border border-grey-light w-full p-3 rounded"
                  type="text"
                  name="description"
                  onChange={onField}
                  placeholder="ขอแสดงความยินดี คุณ ${name} ได้รับสิทธิพิเศษกู้ได้เพิ่มเติม วงเงิน ${amount} ภายในวันที่ ${date}"
                  value={form.description}
                />
                <div className="text-gray-700 text-sm mt-2 font-light">
                  {params.type === "normal"
                    ? "ใส่ ${name} ${amount} และ ${date} ในส่วนของข้อความที่ต้องการใช้ค่าจาก CSV"
                    : "ใส่ ${name} ${lastname} ${totalDue} และ ${date} ในส่วนของข้อความที่ต้องการใช้ค่าจาก CSV"}{" "}
                </div>
              </div>
            </div>
            <div className="pb-6 py-0 px-6">
              <button
                disabled={loadingCreate}
                onClick={onCreateBroadCast}
                className={classNames("", {
                  "w-full": loadingCreate,
                  "duration-300 bg-transparent w-full font-semibold  py-2  border mb-2 border-green-300 p-1 px-2 rounded hover:bg-green-400 text-green-500  hover:text-white":
                    !loadingCreate,
                })}
              >
                {loadingCreate ? <LoadingMutation /> : "Add new broadcast"}
              </button>
              <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </div>
          </div>
        </div>
      </div>
    </ContainerContent>
  );
}

export default BroadCastMain;
